import {
  TRESPONSE_BUNDLE_ALLOWANCE_MASTER,
  TRESPONSE_FATIGUE_ALLOWANCE_MASTER,
  TRESPONSE_MACHINE_MASTER,
  TRESPONSE_OPERATION_MASTER,
  TRESPONSE_PART_MASTER,
  TRESPONSE_PRODUCT_TYPE_MASTER,
  TRESPONSE_STYLE_MASTER,
} from '@monorepo/types';

export type TMastersState = {
  commonMastersData: { [T in TFetchCommonMasterListingSuccessPayload as T['type']]: T['res'] | null };
  fatigueAllowanceListingInfo: TRESPONSE_FATIGUE_ALLOWANCE_MASTER | null;
  bundleAllowanceInfo: TRESPONSE_BUNDLE_ALLOWANCE_MASTER | null;
};

export type TFetchCommonMasterListingSuccessPayload =
  | { type: 'PRODUCT_TYPE'; res: TRESPONSE_PRODUCT_TYPE_MASTER }
  | { type: 'OPERATION'; res: TRESPONSE_OPERATION_MASTER }
  | { type: 'PART'; res: TRESPONSE_PART_MASTER }
  | { type: 'MACHINE'; res: TRESPONSE_MACHINE_MASTER }
  | { type: 'STYLE_NO'; res: TRESPONSE_STYLE_MASTER };

export const MastersActionType = {
  FetchCommonMasterListing: 'FETCH_COMMON_MASTER_LISTING' as const,
  FetchCommonMasterListingSuccess: 'FETCH_COMMON_MASTER_LISTING_SUCCESS' as const,
  FetchCommonMasterListingFailure: 'FETCH_COMMON_MASTER_LISTING_FAILURE' as const,
  FetchFatigueAllowanceList: 'FETCH_FATIGUE_ALLOWANCE_LIST' as const,
  FetchFatigueAllowanceListSuccess: 'FETCH_FATIGUE_ALLOWANCE_LIST_SUCCESS' as const,
  FetchFatigueAllowanceListFailure: 'FETCH_FATIGUE_ALLOWANCE_LIST_FAILURE' as const,
  FetchBundleAllowance: 'FETCH_BUNDLE_ALLOWANCE' as const,
  FetchBundleAllowanceSuccess: 'FETCH_BUNDLE_ALLOWANCE_SUCCESS' as const,
  FetchBundleAllowanceFailure: 'FETCH_BUNDLE_ALLOWANCE_FAILURE' as const,
};
